module.exports = __webpack_public_path__ + "static/media/fa-solid-900.d824df7e.woff2";